import { create } from 'zustand';

export interface MeetingFilterObject {
	filter_date: { flagged: boolean; startDate: Date | null; endDate: Date | null };
	meetingType: string;
	town: string;
	meetingStatus: string;
}

export type MeetingSortValue = 'createddate_desc' | 'createddate_asc' | '';

const initialMeetingFilterObject: MeetingFilterObject = {
	filter_date: { flagged: false, startDate: null, endDate: null },
	meetingType: '',
	town: '',
	meetingStatus: '',
};

interface MeetingFilterStore {
	meetingFilterObject: MeetingFilterObject;
	search: string;
	sortValue: MeetingSortValue;
	updateMeetingFilterObject: (filter: MeetingFilterObject) => void;
	updateMeetingSearch: (search: string) => void;
	updateMeetingSortValue: (sortValue: MeetingSortValue) => void;
	resetMeetingFilterStore: () => void;
}

export const useMeetingFilterStore = create<MeetingFilterStore>((set) => ({
	meetingFilterObject: { ...initialMeetingFilterObject },
	search: '',
	sortValue: '',
	updateMeetingFilterObject: (meetingFilterObject): void =>
		set(() => ({ meetingFilterObject: { ...meetingFilterObject } })),
	updateMeetingSearch: (search): void => set(() => ({ search })),
	updateMeetingSortValue: (sortValue): void => set(() => ({ sortValue })),
	resetMeetingFilterStore: (): void =>
		set(() => ({
			meetingFilterObject: { ...initialMeetingFilterObject },
			search: '',
			sortValue: '',
		})),
}));
